import { render, staticRenderFns } from "./shenheYuceXhjlCrm.vue?vue&type=template&id=e838b430&scoped=true"
import script from "./shenheYuceXhjlCrm.vue?vue&type=script&lang=js"
export * from "./shenheYuceXhjlCrm.vue?vue&type=script&lang=js"
import style0 from "./shenheYuceXhjlCrm.vue?vue&type=style&index=0&id=e838b430&prod&scoped=true&lang=css"
import style1 from "./shenheYuceXhjlCrm.vue?vue&type=style&index=1&id=e838b430&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e838b430",
  null
  
)

export default component.exports